import classNames from "classnames";
import { ComponentProps, PropsWithChildren } from "react";
import { useFormStatus } from "react-dom";
import Icon from "./icon";

type ButtonProps = {
  showLoader?: boolean;
} & ComponentProps<"button"> &
  PropsWithChildren;
const Button = ({ showLoader = false, ...props }: ButtonProps) => {
  const formStatus = useFormStatus();

  return (
    <button
      disabled={formStatus.pending}
      {...props}
      className={classNames(
        props.className,
        "flex justify-center items-center min-h-10"
      )}
    >
      {(!formStatus.pending || !showLoader) && props.children}

      {formStatus.pending && showLoader && (
        <Icon.Loading className="animate-spin h-5" />
      )}
    </button>
  );
};

export default Button;
